module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.closeTransition ? '' : 'el-zoom-in-center'
    }
  }, [_c('span', {
    staticClass: "el-tag",
    class: [_vm.type ? 'el-tag-' + _vm.type : '', {
      'is-hit': _vm.hit
    }],
    style: ({
      backgroundColor: _vm.color
    })
  }, [_vm._t("default"), _vm._v(" "), (_vm.closable) ? _c('i', {
    staticClass: "el-tag-close el-icon-close",
    on: {
      "click": _vm.handleClose
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-1e985586!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/select/src/dependencies/packages/tag/src/tag.vue
// module id = 622
// module chunks = 0